
























































































































import { Employee } from "@/api";
import { selfData } from "@/common/role_utils";
import { VForm } from "@/common/vuetify_types";
import { maxFileSize, requiredString } from "@/tool/validation";
import _ from "lodash";
import { Component, Prop, Vue, Ref } from "vue-property-decorator";

@Component
export default class MessageForm extends Vue {
  @Prop() sendTo!: number[];
  @Ref("form") form!: VForm;
  showAll = false;
  message: string | undefined = "";
  textRules = [requiredString];
  fileRules = [(v: File) => maxFileSize(v, 5)];
  sending = false;
  fileErr = "";
  counter = 0;
  documentName = "";
  url: string | ArrayBuffer | null | undefined = "";
  document: File | null = null;
  res: { errors: string[]; total: number } | null = null;
  to: number[] = [];
  from = "+15203143777";

  employeeId: number[] = JSON.parse(JSON.stringify(this.sendTo || []));

  async created() {
    await this.$store.dispatch("directory/loadAllEmployees", false);
  }

  get employeeIds() {
    return this.showAll ? this.employeeId : this.employeeId.slice(0, 3);
  }

  selectEmployee(employeeId: number) {
    if (this.employeeId.includes(employeeId)) {
      const index = this.employeeId.indexOf(employeeId);
      this.employeeId.splice(index, 1);
    } else {
      this.employeeId.push(employeeId);
    }
  }

  getEmployeeName(id: number): string {
    const employees = this.$store.state.directory.employees;
    const employee = _.find(
      employees,
      (employee: Employee) => employee.id == id,
    );
    return `${employee?.firstName} ${employee?.lastName}`;
  }

  onChangeFile(file: File) {
    this.fileErr = "";
    this.counter++;
    if (file) {
      const reader = new FileReader();

      reader.onload = (event: ProgressEvent<FileReader>) => {
        if (event) {
          this.documentName = file.name;
          this.url = URL.createObjectURL(file);
        }
      };
      reader.readAsArrayBuffer(file);
      this.document = file;
    }
  }

  async submit() {
    this.res = null;
    this.to = this.employeeId;
    this.sending = true;
    const payload = {
      message: this.message,
      to: this.to,
      from: this.from,
      file: this.document || undefined,
      companyId: selfData().companyId,
    };

    const res = await this.$store.dispatch("sms/smsWithMedia", payload);
    this.res = res;
    this.clearPayload();
    this.sending = false;
  }

  clearPayload() {
    this.message = undefined;
    this.to = [];
    this.employeeId = [];
    this.document = null;
    this.form.reset();
    this.form.resetValidation();
  }

  close() {
    this.$emit("close");
  }
}
